import { cn } from '@repo/tailwind-config/tailwind.functions'
import { conditionalRender } from '@repo/toolkit/conditional-render'
import { useQuery } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useFormContext, useWatch } from 'react-hook-form'

import { getRads } from '../../../api/rads/get-rads'
import { AffectedStaffInput } from '../../../lib/types/models/affectedStaff/affected-staff-input'
import { CenterProperties } from '../../../lib/types/models/center/properties.center'
import { FormControl, FormField, FormItem } from '../../elements/forms/form'
import ControlledHourInput from '../../elements/inputs/controlled-hour-input'
import ControlledSelectInput from '../../elements/inputs/controlled-select-input'

type Props = {
  mode?: 'create' | 'view'
  radPlaceholder?: string
}
export function AffectStaffRadFormFields({ mode = 'create', radPlaceholder }: Props) {
  const form = useFormContext<AffectedStaffInput>()

  const { data: rads } = useQuery({
    queryKey: ['rads'],
    queryFn: () => getRads()
  })

  const radId = useWatch({ control: form.control, name: 'associatedRadId' })

  // Set the default value for appointmentTime based on the selected radId
  useEffect(() => {
    if (!radId) return
    const rad = rads?.data.find((rad) => rad.id === radId)
    if (rad && rad.hours) {
      form.setValue('appointmentTime', rad.hours)
    }
  }, [radId, rads?.data])

  return (
    <div className={cn('flex gap-3', { 'flex-col': mode === 'view' })}>
      <FormField
        control={form.control}
        name={'associatedRadId'}
        render={({ field }) => (
          <FormItem className={'flex-1'}>
            <FormControl>
              <ControlledSelectInput
                {...field}
                dropDownPosition="above"
                label={radPlaceholder ?? 'Date de réunion avant départ'}
                options={rads?.data.map((rad) => ({
                  label: CenterProperties.getRadNameForRequestStaff(rad),
                  value: rad.id
                }))}
                selectedOption={conditionalRender(!!field.value, {
                  label: CenterProperties.getRadNameForRequestStaff(
                    rads?.data.find((rad) => rad.id === field.value)
                  ),
                  value: field.value
                })}
              />
            </FormControl>
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name={'appointmentTime'}
        render={({ field }) => (
          <FormItem className="flex-1">
            <FormControl>
              <ControlledHourInput {...field} required label={'Heure de convocation'} />
            </FormControl>
          </FormItem>
        )}
      />
    </div>
  )
}
